import type { RouteRecordRaw } from "vue-router"
import { routePaths } from "@/router/routePaths"
import { featureCheck, CX_CORE_FEATURES_ENUM } from "@/common/util/featuresUtil"

const manageRoutes: RouteRecordRaw[] = [
  {
    path: "/manage",
    name: "manage",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.jobs.path,
        name: routePaths.jobs.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.JOBS)
            ? import("@/modules/monitor/jobs/pages/Jobs.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Maintain",
              translationKey: "sideMenu.monitoring",
              routeName: ""
            },
            {
              title: "Jobs",
              translationKey: "sideMenu.jobs"
            }
          ]
        }
      }
    ]
  }
]

export default manageRoutes
